import { Flex } from "@chakra-ui/react";
import { format } from "date-fns";
import { FC, useCallback, useContext, useState } from "react";
import { useLazyLoadQuery } from "react-relay";
import { useParams } from "react-router-dom";
import { graphql } from "relay-runtime";

import { SiteReportOrder } from "~/src/__generated__/schema";
import { GenderReportContainer_Query } from "~/src/__relay_artifacts__/GenderReportContainer_Query.graphql";
import { DateRangeContext } from "~/src/components/features/global/HeaderNavigation/DateRangeField";

import { ReportFilterButton, ReportFilterValues } from "../ReportFilterButton";

import { GenderReportGraph } from "./GenderReportGraph";
import { GenderReportTable } from "./GenderReportTable";

export type Props = {};

const query = graphql`
  query GenderReportContainer_Query($slug: String!, $input: ReportInput!) {
    site(slug: $slug) {
      ...GenderReportGraph_site
      ...GenderReportTable_site
    }
  }
`;

export const GenderReportContainer: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = () => {
  const { siteSlug = "" } = useParams();

  const [sort, setSort] = useState<SiteReportOrder>({
    field: "UNIQUE_USER",
    direction: "DESC",
  });

  const {
    dateRange: [startOn, endOn],
  } = useContext(DateRangeContext);

  const [filterValues, setFilterValues] = useState<ReportFilterValues>({
    sourceId: null,
    device: null,
    funnelIds: [],
    pageKind: null,
  });

  const handleSortClick = useCallback((params: any) => setSort(params), []);

  const { site } = useLazyLoadQuery<GenderReportContainer_Query>(query, {
    slug: siteSlug,
    input: {
      startDate: format(startOn, "yyyy-MM-dd"),
      endDate: format(endOn, "yyyy-MM-dd"),
      funnelIds: filterValues.funnelIds,
      sourceId: filterValues.sourceId,
      device: filterValues.device,
      pageKind: filterValues.pageKind,
      orderBy: {
        field: sort.field,
        direction: sort.direction,
      },
    },
  });

  return (
    <>
      <Flex justifyContent={"end"} mt={4} mb={4}>
        <ReportFilterButton
          filterValues={filterValues}
          onSubmit={setFilterValues}
          onFilterChange={setFilterValues}
        />
      </Flex>
      <GenderReportGraph siteRef={site} />
      <GenderReportTable siteRef={site} onSortClick={handleSortClick} />
    </>
  );
};
